import React from 'react';
import { ArrowLeft, Clock } from 'lucide-react';

function DeliveryHeader({ delivery, formattedArrivalTime, totalCharged, onBack }) {
  const recipientName = delivery?.recipient_name || '';
  const displayName = recipientName.length > 25 
    ? `${recipientName.substring(0, 25)}...` 
    : recipientName;

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm">
      <div className="px-4 py-3">
        {/* Top Row - Name and Back Button */}
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-xl font-bold text-gray-900 flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-brand-primary text-white text-sm font-bold">
              {delivery?.sequence}
            </span>
            {displayName}
          </h1>
          
          <button
            onClick={onBack}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Volver"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        {/* Bottom Row - Order Details */}
        <div className="flex items-center justify-between text-sm">
          <div className="flex flex-col gap-0.5">
            <p className="text-gray-600">
              {delivery?.user_name} • ID: {delivery?.id}
            </p>
            {delivery?.charge > 0 && (
              <p className="font-bold text-brand-primary text-base">
                A Cobrar: S/ {delivery.charge.toFixed(2)}
              </p>
            )}
            {totalCharged > 0 && (
              <p className="font-semibold text-brand-green text-sm">
                Cobrado: S/ {totalCharged.toFixed(2)}
              </p>
            )}
          </div>

          {/* Arrival Time */}
          {formattedArrivalTime && (
            <div className="flex items-center gap-1.5 text-gray-700">
              <Clock className="w-4 h-4" />
              <span className="font-medium">{formattedArrivalTime}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DeliveryHeader;